import { DEFAULT_LOCALE } from '~/universal/constants';

export const fallbackLng = DEFAULT_LOCALE;
export const languages = [fallbackLng, 'ru', 'en'];
const defaultNS = 'translation';

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}
